export default __webpack_public_path__ + "static/media/plus-icon.f15444a5.svg";